import {combineReducers} from "redux";
import {persistReducer} from "redux-persist";
import carsReducer from "./cars/cars.reducer";
import mapReducer from "./map/map.reducer";
import modalsReducer from "./modals/modals.reducer";
import userReducer from "./user/user.reducer";
import formReducer from "./form/form.reducer"
import storage from 'redux-persist/lib/storage';

const persistConfig ={
    key: 'root',
    storage,
    whitelist: ['user']
}


const rootReducer = combineReducers({
    map: mapReducer,
    cars: carsReducer,
    modals: modalsReducer,
    form: formReducer,
    user: userReducer
});

export default persistReducer(persistConfig,rootReducer);